module.exports = __webpack_public_path__ + "static/media/Yelpcamp_small.db9a65ab.JPG";